// extracted by mini-css-extract-plugin
export default {"introDesc":"introduction_introDesc__wD2JJ","profile":"introduction_profile__wcypc","connect":"introduction_connect__2E2xT","buttonContact":"introduction_buttonContact__Ze9J4"};